import { Component, OnInit } from '@angular/core';
import { ValidationErrors, Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

import { ProductDao } from '@app/dao/product/product.dao';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Big } from 'big.js';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@UntilDestroy()
@Component({
  selector: 'girardi-amount',
  templateUrl: './girardi-amount.component.html',
  styleUrls: ['./girardi-amount.component.scss'],
  standalone: false,
})
export class GirardiAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  error: ValidationErrors = null;
  loading: boolean = false;
  sessionConsultant: boolean = false;
  isFinancileOrOseomSubscription: boolean = false;
  financileRate: number | null = null;
  minRate: number = 0;
  maxRate: number = 8;
  maxSubscriptionAmount: number = Infinity;
  minSubscriptionAmount: number = 0;
  pledge: PledgeRead;
  parameters: Parameters;
  GIRARDIN_INVESTMENT_AMOUNT = CompanyFieldType.GIRARDIN_INVESTMENT_AMOUNT;
  GIRARDIN_COMMISSION_RATE = CompanyFieldType.GIRARDIN_COMMISSION_RATE;
  GIRARDIN_TAX_REDUCTION_AMOUNT =
    CompanyFieldType.GIRARDIN_TAX_REDUCTION_AMOUNT;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.loading = true;
    this.pledge = this.subscriptionFacade.getPledge();
    const pledgeProduct = this.pledge?.products?.[0];
    const isFinancileOrOseomSubscription =
      pledgeProduct?.parameters?.partnerFlux === 'FINANCILE' ||
      pledgeProduct?.parameters?.partnerFlux === 'OSEOM';
    this.isFinancileOrOseomSubscription = isFinancileOrOseomSubscription;
    this.parameters = this.pledge?.parameters;
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;

    this.productDao
      .getProduct(pledgeProduct.productId.toString())
      .subscribe(product => {
        const maxAvailable = product?.montantDisponible || 0;
        this.financileRate = product?.financialTaxReductionPercent || null;
        this.maxSubscriptionAmount = maxAvailable;
        this.loading = false;
        this.subscriptionFacade.initForm(this, {
          ...this.parameters,
        });
        this.formValueChanges();
        const subscriptionAmount = this.products
          ?.get(`${0}`)
          ?.get('parameters')
          ?.get(this.feilds.investmentAmount)?.value;

        if (subscriptionAmount) {
          const rateAmount = new Big(subscriptionAmount)
            .times(this.financileRate || 0)
            .toNumber();
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get(this.feilds.taxReductionAmount)
            .setValue(rateAmount);
        }

        this.products
          ?.get(`${0}`)
          ?.get('parameters')
          ?.get(this.feilds.investmentAmount)
          .valueChanges.subscribe(amount => {
            const rateAmount = new Big(amount)
              .times(this.financileRate || 0)
              .toNumber();
            this.products
              ?.get(`${0}`)
              ?.get('parameters')
              ?.get(this.feilds.taxReductionAmount)
              .setValue(rateAmount);
          });
      });
  }
  formValueChanges() {
    this.subscriptionFacade
      .setupFormValueAmountChanges(
        this.form,
        this.feilds,
        this.sessionConsultant,
      )
      .pipe(untilDestroyed(this))
      .subscribe(error => {
        this.error = error;
      });
  }
  setRateCommisionValidation() {
    this.products
      ?.get(`${0}`)
      ?.get('parameters')
      ?.get(this.feilds.girardinCommissionRate)
      .setValidators([Validators.required]);
    this.form.updateValueAndValidity();
  }
  onSubmit() {
    this.form.markAsDirty();

    const amount = this.products
      ?.get(`${0}`)
      ?.get('parameters')
      ?.get(this.feilds.investmentAmount)?.value;

    if (
      !this.isAmountMultipleOfTen(amount) &&
      this.isFinancileOrOseomSubscription
    ) {
      this.error = {
        invalid: true,
        message: 'Le montant de la souscription doit être un multiple de 10.',
      };
    }

    if (!this.error) {
      this.subscriptionFacade.submitPledge(this);
    }
  }

  isAmountMultipleOfTen(amount: number) {
    return amount % 10 === 0;
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
